// extracted by mini-css-extract-plugin
export default {"imgdiv":"_8336f7fae3 _85d1a09839","img":"f5364b9463 _2ea0882086"};